const translate = (key: string, fallback: string) => {
  const local = localStorage.getItem("language") || "en";
  const userCulture = local === "ar" ? "ar" : "en";
  const translations = {
    en: require("../translations.json")["en"],
    ar: require("../translations.json")["ar"],
  };

  const translation = translations[userCulture]
    ? translations[userCulture][key]
    : fallback;

  return translation || fallback;
};

export default translate;
